<div class="thanks-page">
    <div class="container">
        <div class="row mt-5 pt-5 mb-5">
            <div class="col-sm-12">
                <div class="thanks-center">
                    <div class="heading-missingpets">
                        <h1>
                            {{'Annonsen din er klar!' | translate}}
                        </h1>
                    </div>
                    <div *ngIf="registerSuccess" style="text-align: center;">
                        <p class="thanks-para">
                            Vi håper du raskt blir gjenforent med kjæledyret ditt. 
                            Når kjæledyret ditt er vel hjemme igjen, så husk å markere det som Gjenforent på Savnet & Funnet profilen.
                        </p>
                        <div class="thanks-btn">
                            <a (click)="goToPetDetail()" class="btn btn-white custom-40 mb-2 scroll-btn" type="btn">
                                Se annonse<i class="fas fa-arrow-right"></i></a>
                        </div>
                    </div>
                </div>
            </div>
            <app-search></app-search>
        </div>
    </div>
</div>